export default __webpack_public_path__ + "static/media/ic-bris-de-glace.246e1e96.svg";